import { formatRupiah } from "@/helpers/utils";
import ApiService from '@/services/api';
import { _ } from "gridjs-react";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { h } from "gridjs";


const getStatusBadge = (status) => {
  const badges = {
    process: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    approved: 'bg-green-100 text-green-800 border-green-300',
    rejected: 'bg-red-100 text-red-800 border-red-300',
    submitted: 'bg-gray-100 text-gray-800 border-gray-300'
  };
  return badges[status] || 'bg-gray-100 text-gray-800 border-gray-300';
};

export const columns = [
  {
    name: 'Tanggal Pengajuan',
    data: (row) => row.application_date,
    formatter: (row) => {
      return _(
        <span>
          {dayjs(row?.application_date).format('DD/MM/YYYY') || 'N/A'}
        </span>
      )
    }
  },
  {
    name: 'Nama Anggota',
    data: (row) => row?.member?.full_name
  },
  {
    name: 'Jenis Produk Pinjaman',
    data: (row) => row?.loan_product?.name
  },
  {
    name: 'Nominal',
    data: (row) => formatRupiah(row?.principal_amount)
  },
  {
    name: 'Tenor',
    data: (row) => row?.term_months
  },
  {
    name: 'Status',
    data: (row) => row.status,
    formatter: (cell) => {
      const badgeClass = getStatusBadge(cell);
      return _(<span className={`text-gray-900 px-3 py-1 text-sm font-semibold rounded-md border ${getStatusBadge(cell)}`}>{cell}</span>);
    }
  },
  {
    name: 'Info',
    data: (row) => row,
    formatter: (row) => {
      const handleClick = async (action) => {
        try {
          const response = await ApiService.approvalLoan(row.id, action, row.principal_amount, row.term_months);
          if (response.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'Sukses!',
              text: 'Pemeriksaan Berkas Success!',
            }).then(() => {
              window.location.reload()
            });
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: error || 'Failed Action',
          });
        }
      };

      const approveButton = h('button', {
        className: 'rounded-md bg-green-400 hover:bg-green-500 text-white py-1 p-2',
        onClick: () => handleClick('approve'),
      }, 'Setujui Pengajuan');
      
      const rejectButton = h('button', {
        className: 'rounded-md bg-red-400 hover:bg-red-500 text-white py-1 p-2',
        onClick: () => handleClick('reject'),
      }, 'Tolak Pengajuan');

      const detailButton = h('a', {
        className: 'rounded-md bg-blue-500 hover:bg-blue-600 text-white py-1 p-2',
        href: `/admin/loans-validation/${row.id}/detail`,
      }, 'Detail');

      const containerDiv = h('div', {
        className: 'flex flex-col gap-3'
      },detailButton,approveButton,rejectButton);

      return containerDiv;
    }
  }
]

export const historySavingColumns = [
  {
    name: 'Tanggal Penyetoran',
    data: (row) => row.transaction_date,
    formatter: (row) => {
      return _(
        <span>
          {dayjs(row?.transaction_date).format('DD/MM/YYYY') || 'N/A'}
        </span>
      )
    }
  },
  {
    name: 'Produk Simpanan',
    data: (row) => row,
    formatter: (row) => {
      return _(
        <span>{ row?.member_savings_account?.savings_type?.name }</span>
      )
    }
  },
  {
    name: 'Saldo',
    data: (row) => row.amount,
    formatter: (cell) => {
      return _(
        <span>{ formatRupiah(cell) }</span>
      )
    }
  }
]